import { useNavigate } from 'react-router-dom'
import { InformationCircleIcon, ClockIcon } from '@heroicons/react/24/outline'

import bandaidIcon from 'media/icons/bandaid.png'

import ContentFrame from 'components/Frame/ContentFrame'

export default function ActiveInjuriesBox({ injuries = null }) {

    const navigate = useNavigate()

    const FormatInjuryType = (injuryType) => {
        return injuryType
            .split('-')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
    }

    const FormatDuration = (injury) => {
        if (!injury.createdTimestamp) return ''
        
        const createdDate = new Date(injury.createdTimestamp)
        const now = new Date()
        var weeks = Math.floor((now - createdDate) / (1000 * 60 * 60 * 24 * 7))

        weeks = Math.max(weeks, 1)
        
        return `${weeks} week${weeks > 1 ? 's' : ''}`
    }

    if (injuries === null) return <></>

    return (
        <ContentFrame
            titleText="Active Injuries"
            titleIcon={<InformationCircleIcon className="mt-0.5 w-5 h-5 text-gray-800" />}
            toolTipText="Athletes with active injury program overrides"
        >
            {injuries.length === 0 && 
                <div className="h-full flex flex-col items-center justify-center py-16 space-y-2">
                    <img src={bandaidIcon} alt="Bandaid Icon" className="h-16 w-16 invert opacity-20 mb-4" />

                    <p className="text-sm text-gray-500 text-center">No injuries active for any athletes</p>

                    <p className="text-sm text-gray-500 text-center">Keep it up!</p>
                </div> 
            }

            {injuries.length > 0 && 
                <div className='w-full h-full divide-y divide-gray-200 overflow-y-auto webkit-scrollbar-hidden [-ms-overflow-style:none] [scrollbar-width:none]'>
                    {injuries.map((injury, index) => (
                        <div 
                            key={index} 
                            className="flex items-center py-4 px-6 gap-x-4 cursor-pointer hover:bg-gray-50"
                            onClick={() => navigate(`/athlete/${injury.userId}`)}
                        >
                            <div>
                                <div className="h-12 w-12 bg-orange-400 rounded-full flex items-center justify-center">
                                    <img src={bandaidIcon} alt="Bandaid Icon" className="h-7 w-7 mr-[1px]" />
                                </div>
                            </div>

                            <div className="flex-grow">
                                <p className="font-semibold">{FormatInjuryType(injury.injuryType)}</p>
                                <p className="text-sm">{injury.firstName} {injury.lastName}</p>
                            </div>

                            <div className="flex items-center gap-x-1">
                                <ClockIcon className="h-5 w-5 text-gray-500" />
                                <p className="text-center text-sm text-gray-600">{FormatDuration(injury)}</p>
                            </div>
                        </div>
                    ))}
                </div>
            }
        </ContentFrame>
    )
}

